import {AppBlock} from "@ok/web/modules/block/AppBlock";
import { ClipsFullscreenStore} from "./ClipsFullscreenStore";
import {ClipsFullscreen} from "../components/ClipsFullscreen/ClipsFullscreen";
import {ClipsFullscreenController} from "./ClipsFullscreenController";
import {IClipsFullscreenAttrs} from "./ClipsFullscreenAttrs";
import {Clip} from "./types";

export class ClipsFullscreenBlock extends AppBlock<IClipsFullscreenAttrs, {}, ClipsFullscreenStore, ClipsFullscreenController> {
    getAppAPI() {
        return {
            appendFirst: (item: Clip, initTarget: HTMLDivElement) => this.ctrl.store.appendFirst(item, initTarget),
            setOpenState: (state: boolean) => this.ctrl.store.setOpenState(state)
        };
    }

    getAppEntities() {
        return {
            Store: ClipsFullscreenStore,
            Controller: ClipsFullscreenController,
            Component: ClipsFullscreen
        };
    }

    static destroy() {
        //keep alive;
    }
}
